import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Collabora from "../pages/collabora/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collabora",
    element: <Collabora />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
